<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Transactions</div>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-xs-6">
            <el-select
              class="select-default"
              v-model="limits.period"
              placeholder="Per page"
              @change="updateTable($event)">
              <el-option
                class="select-default"
                v-for="item in limits.periods"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="col-xs-6">
            <div class="pull-right">
              <label>
                <input type="search" class="form-control input-sm" placeholder="Search transactions" v-model="searchQuery" aria-controls="datatables">
              </label>
            </div>
            <div class="pull-right" style="padding-right: 1em;">
              <div>
                <strong>Total:</strong>
                <span class="totals-value">&nbsp;{{ (Math.round(parseFloat(this.data.totals.amount) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
              </div>
              <div>
                <strong>Transactions:</strong>
                <span class="totals-value">&nbsp;{{ this.data.totals.entries.toLocaleString('en-US') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table class="table-striped"
                      :data="queriedData"
                      border
                      style="width: 100%">
              <el-table-column v-for="column in tableColumns"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :width="column.width"
                              :fixed="column.fixed"
                              :show-overflow-tooltip="true"
                              :prop="column.prop"
                              :label="column.label"
                              :formatter="column.formatter">
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{this.data.from === null ? 0 : this.data.from}} to {{this.data.to === null ? 0 : this.data.to}} of {{this.data.total}} entries</p>
          </div>
          <div class="col-sm-6">
            <el-pagination class="pull-right" layout="prev, pager, next" :page-size="this.data.per_page" :total="this.data.total" @current-change="updateLimit($event)"></el-pagination>
          </div>
          <div v-if="this.$store.state.managerData.GroupId === 1 && this.data.to === this.data.total">
            You've reached the end of your account activity.  If you have older account activity that is not shown, please contact Providence First Trust Company.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    computed: {
      queriedData () {
        if (!this.searchQuery || this.searchQuery.length < 2) {
          // this.results === null is for initial load
          // previousQuery != searchQuery is when query is cleared to nothing.
          if (this.data.data === null || this.previousQuery !== this.searchQuery) {
            this.updateTable()
            this.previousQuery = this.searchQuery
          }
        } else if (this.previousQuery !== this.searchQuery) {
          this.previousQuery = this.searchQuery
          this.searchCount++
          let currentCheck = this.searchCount
          setTimeout(() => {
            if (this.searchQuery.length >= 2 && this.searchCount === currentCheck) { // Check closure of searchCount to see if done typing
              this.updateTable()
            }
          }, 200)
        }
        return this.data.data
      }
    },
    data () {
      return {
        limits: {
          period: '30',
          periods: [
            {
              value: '30',
              label: '30 days'
            },
            {
              value: '90',
              label: '90 days'
            },
            {
              value: '12mo',
              label: 'Last 12 Months'
            },
            {
              value: 'ytd',
              label: 'YTD'
            },
            {
              value: 'all',
              label: 'All Time'
            }
          ]
        },
        searchQuery: '',
        previousQuery: null,
        searchCount: 0,
        tableColumns: [
          {
            prop: 'TransDate',
            label: 'Date',
            width: 110,
            formatter: (row, column, cellValue) => {
              return (this.moment(cellValue).format('MM/DD/YYYY'))
            }
          },
          {
            prop: 'Name',
            label: 'Name',
            width: 200
          },
          {
            prop: 'TribalId',
            label: 'Tribal ID',
            minWidth: 110
          },
          {
            prop: 'TransPayee',
            label: 'Description',
            minWidth: 200
          },
          {
            prop: 'TransAmount',
            label: 'Amount',
            fixed: 'right',
            minWidth: 100,
            formatter: (row, column, cellValue) => {
              return (Math.round(parseFloat(cellValue) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
            }
          }
        ],
        // give some initial values before a request is made
        data: {
          per_page: 100,
          from: 0,
          to: 0,
          total: 0,
          data: []
        },
        pagination: {
          currentPage: 1,
          perPage: 100
        }
      }
    },
    methods: {
      updateLimit: function (limit) {
        this.pagination.currentPage = limit
        this.updateTable()
      },
      updateTable: function () {
        this.getTransactionData()
      },
      getTransactionData: function () {
        if (this.$store.state.managerData.GroupId !== 0) {
          var url = '/manager/groups/' + this.$store.state.managerData.GroupId + '/contributions/' + this.limits.period
          // add in pagination parameters
          url += ('?page=' + this.pagination.currentPage + '&limit=' + this.pagination.perPage)
          url += '&q=' + this.searchQuery

          this.$http.get(url)
          .then(response => {
            this.data = response.data
          })
        }
      }
    },
    created () {
    },
    mounted () {
      this.getTransactionData()
    }
  }
</script>
<style>

.el-table .cell {
  word-break: normal;
  overflow-wrap: normal;
}
.totals-value {
  float: right;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/RecentContributions.vue